import React from 'react';

interface WheelProps {
  rotation: number;
  isSpinning: boolean;
}

export const Wheel: React.FC<WheelProps> = ({ rotation, isSpinning }) => {
  return (
    <div className="relative w-64 h-64 md:w-80 md:h-80 mx-auto flex items-center justify-center">
      <svg
        className="absolute inset-0"
        style={{ 
          transform: `rotate(${rotation}deg)`,
          transition: isSpinning ? 'none' : 'transform 0.3s ease-out'
        }}
        viewBox="0 0 100 100"
      >
        {/* Main wheel circle */}
        <circle cx="50" cy="50" r="45" fill="#f8f9fa" stroke="#2f3542" strokeWidth="3"/>
        
        {/* Numbers and sections */}
        {Array.from({ length: 20 }).map((_, i) => {
          const angle = (i * 18);
          const number = i * 5;
          return (
            <g key={i}>
              <path
                d={`M 50 50 L ${50 + 45 * Math.cos(angle * Math.PI / 180)} ${50 + 45 * Math.sin(angle * Math.PI / 180)} A 45 45 0 0 1 ${50 + 45 * Math.cos((angle + 18) * Math.PI / 180)} ${50 + 45 * Math.sin((angle + 18) * Math.PI / 180)} Z`}
                fill={i % 2 === 0 ? '#f1f2f6' : '#dfe4ea'}
                stroke="#a4b0be"
                strokeWidth="0.5"
              />
              <text
                x={50 + 38 * Math.cos((angle + 9) * Math.PI / 180)}
                y={50 + 38 * Math.sin((angle + 9) * Math.PI / 180)}
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize="4"
                fontWeight="bold"
                fill="#2f3542"
                transform={`rotate(${angle + 9}, ${50 + 38 * Math.cos((angle + 9) * Math.PI / 180)}, ${50 + 38 * Math.sin((angle + 9) * Math.PI / 180)})`}
              >
                {number}
              </text>
            </g>
          );
        })}
        
        {/* Center decoration */}
        <circle cx="50" cy="50" r="5" fill="#2f3542"/>
        <circle cx="50" cy="50" r="3" fill="#747d8c"/>
      </svg>
      
      {/* Pointer */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1">
        <svg width="16" height="24" viewBox="0 0 16 24">
          <path d="M8 24L0 0L8 6L16 0L8 24Z" fill="#dc2626"/>
        </svg>
      </div>
    </div>
  );
}; 